export const resolvePermanentUrl = (value: string | null | undefined): string | undefined =>
  typeof value === 'string' && value.length > 0 ? value : undefined;
